<template>
	<div>

    <div style=" width:100%;
    height: 200px;
    text-align: center; line-height: 200px; font-size: 26px;">歡迎使用,巡檢管理系統</div>
		<!-- <el-card class="box-card" shadow="never">
			<div slot="header" class="clearfix">
				<span>后台首页</span>
			</div>
		</el-card> -->
		<!-- <div class="mr-t15">
			<el-row :gutter="20">
			  <el-col :span="24">
				  <el-card class="box-card" shadow="never">
				  	<div slot="header" class="clearfix">
				  		<span>快捷入口</span>
				  	</div>
					<el-row :gutter="20">
						<el-col :span="6" v-for="(item,index) in fastIn" :key="index">
							<div class="text-center fast" @click="jump(item.path)">
								<i :class="item.icon"></i>
								<div>{{item.name}}</div>
							</div>
						</el-col>
					</el-row>
				  </el-card>
			  </el-col>
			</el-row>
		</div> -->
	</div>
</template>

<script>
	export default {
		data() {
			return {
				fastIn:[
					// {name:"图库管理",icon:"el-icon-picture",path:"/picture/pictureList"},
					// {name:"商品管理",icon:"el-icon-box",path:"/product/ProductList"},
					// {name:"订单管理",icon:"el-icon-tickets",path:"/order/OrderList"},
					// {name:"用户管理",icon:"el-icon-user",path:"/user/UserList"},
				]
			}
		},
		created() {

		},
		mounted() {

		},
		methods: {
			jump(path){
				this.$router.push({
					path:path
				})
			}
		}
	}
</script>

<style scoped>
	.fast{
		cursor: pointer;
	}

	.fast i{
		font-size:30px;
		margin-bottom:5px;
	}
</style>



// WEBPACK FOOTER //
// src/views/main/Main.vue